import React from 'react';
import {useTranslation} from 'react-i18next';

import {
    ThemeProvider,
    Row,
    List,
    TextLink,
    FontVariant,
} from '@pexip/components';
import {SettingsPanel} from '@pexip/media-components';

import {FALLBACK_LANGUAGES, LANGUAGE_NAMES, type LngKey} from '../i18n';

const IGNORED_LANGUAGES = [...FALLBACK_LANGUAGES, 'cimode'];

export const Languages: React.FC = () => {
    const {i18n} = useTranslation();
    return (
        <SettingsPanel>
            <ThemeProvider colorScheme="light">
                <List>
                    {i18n.options.supportedLngs &&
                        typeof i18n.options.supportedLngs !== 'boolean' &&
                        i18n.options.supportedLngs
                            ?.filter(
                                lngKey => !IGNORED_LANGUAGES.includes(lngKey),
                            )
                            .map(lngKey => {
                                const isSelected = lngKey === i18n.language;
                                return (
                                    <Row key={lngKey}>
                                        <TextLink
                                            onClick={() =>
                                                i18n.changeLanguage(lngKey)
                                            }
                                            aria-current={isSelected}
                                            variant="standard"
                                            fontVariant={
                                                isSelected
                                                    ? FontVariant.BodyBold
                                                    : FontVariant.Body
                                            }
                                        >
                                            {LANGUAGE_NAMES[lngKey as LngKey] ||
                                                lngKey}
                                        </TextLink>
                                    </Row>
                                );
                            })}
                </List>
            </ThemeProvider>
        </SettingsPanel>
    );
};
